import { connect } from "react-redux";

var CurrentUser = require("lib/account/CurrentUser");
var Glyphicon = require("components/utility/icons/Glyphicon");
var WidgetConfig = require('lib/widgets/WidgetsConfig')

var WritingSelectors = require("lib/selectors/WritingSelectors");

require("data/book_answers_analysis_table");

@connect(
  (state, props) => ({
    answers: WritingSelectors.answers({state, conditions: { textID: props.textID, userID: props.userID }, filters: { draft: false } })
  }),
  () => ({})
)

class BookAnswersAnalysisTable extends React.Component {
  constructor(props) {
    super();
    autobind(this);

    this.state = {
      expandedRows: []
    }
  }

  expandWriting(rowIndex) {
    if (_.includes(this.state.expandedRows, rowIndex)) {
      this.setState({ expandedRows: [..._.omit(this.state.expandedRows, rowIndex)] })
    } else {
      this.setState({ expandedRows: [...this.state.expandedRows, rowIndex] })
    }
  }

  generateSummary() {
    return (
      <div className='summary'>
        <span className='summaryTitle'>Answers Summary:</span>
        <div className='yesSummary'>
          <span className="yesBlock backgroundColor-green fontColor-green">Yes</span> - 5
        </div>
        <div className='maybeSummary'>
          <span className="maybeBlock backgroundColor-yellow fontColor-yellow">Maybe</span> - 1
        </div>
        <div className='noSummary'>
          <span className="noBlock backgroundColor-red fontColor-red">No</span> - 1
        </div>
      </div>
    )
  }

  generateAnswer(rowIndex) {
    if (_.includes(this.state.expandedRows, rowIndex)) {
      return ANSWERS[rowIndex]
    }
  }

  generateRows() {
    
  }
  generateHeaders() {
    return _.map(COLUMN_HEADERS, (header, index) => {
      return <th key={index} className={`columnHeader`}>{header}</th>
    })
  }

  render() {
    return (
      <div className="bookAnswersAnalysisTable">
        {this.generateSummary()}
        <table className="table">
          <thead>
            <tr>
              {this.generateHeaders()}
            </tr>
          </thead>
          <tbody>
            <tr>
              <td colSpan={1} className={`cell readBookCellContainer`}>
                <div className={`readBookCell backgroundColor-green`}>
                  <div className={`readBookCellValue fontColor-green`}>Yes</div>
                </div>
              </td>
              <td colSpan={1} className={`cell centerCell typeCell`}>
                FITB
              </td>
              <td colSpan={1} className={`cell questionCell`}>
                Castle steals _____ from a store.
              </td>
              <td colSpan={1} className={`cell centerCell reasonCell`}>
                Correct
              </td>
              <td colSpan={1} className={`cell viewCell`}>
                <a onClick={() => this.expandWriting(0)}>
                  <Glyphicon icon="new-window" />
                </a>
              </td>
            </tr>
            {this.generateAnswer(0)}
          </tbody>
          
            <tbody>
              <tr>
                <td colSpan={1} className={`cell`}>
                  <div className={`readBookCell backgroundColor-red`}>
                    <div className={`readBookCellValue fontColor-red`}>No</div>
                  </div>
                </td>
                <td colSpan={1} className={`cell centerCell`}>
                  FITB
                </td>
                <td colSpan={1} className={`cell`}>
                  Ghost's _____ tries to shoot him.
                </td>
                <td colSpan={1} className={`cell centerCell`}>
                  Inorrect
                </td>
                <td colSpan={1} className={`cell`}>
                  <a onClick={() => this.expandWriting(1)}>
                    <Glyphicon icon="new-window" />
                  </a>
                </td>
            </tr>
            {this.generateAnswer(1)}
            </tbody>
          
            <tbody>
              <tr>
                <td colSpan={1} className={`cell`}>
                  <div className={`readBookCell backgroundColor-green`}>
                    <div className={`readBookCellValue fontColor-green`}>Yes</div>
                  </div>
                </td>
                <td colSpan={1} className={`cell centerCell`}>
                  FITB
                </td>
                <td colSpan={1} className={`cell`}>
                  Castle joins the _____ team.
                </td>
                <td colSpan={1} className={`cell centerCell`}>
                  Correct
                </td>
                <td colSpan={1} className={`cell`}>
                  <a onClick={() => this.expandWriting(2)}>
                    <Glyphicon icon="new-window" />
                  </a>
                </td>
            </tr>
            {this.generateAnswer(2)}
            </tbody>
          
            <tbody>
              <tr>
                <td colSpan={1} className={`cell`}>
                  <div className={`readBookCell backgroundColor-green`}>
                    <div className={`readBookCellValue fontColor-green`}>Yes</div>
                  </div>
                </td>
                <td colSpan={1} className={`cell centerCell`}>
                  FITB
                </td>
                <td colSpan={1} className={`cell`}>
                  Castle steals sunflower seeds from a _____.
                </td>
                <td colSpan={1} className={`cell centerCell`}>
                  Correct
                </td>
                <td colSpan={1} className={`cell`}>
                  <a onClick={() => this.expandWriting(3)}>
                    <Glyphicon icon="new-window" />
                  </a>
                </td>
            </tr>
            {this.generateAnswer(3)}
            </tbody>
          
            <tbody>
              <tr>
                <td colSpan={1} className={`cell`}>
                  <div className={`readBookCell backgroundColor-yellow`}>
                    <div className={`readBookCellValue fontColor-yellow`}>Maybe</div>
                  </div>
                </td>
                <td colSpan={1} className={`cell centerCell`}>
                  Quiz Free Response
                </td>
                <td colSpan={1} className={`cell`}>
                  Does the relationship between two characters make each character better or worse? Use details about the relationship to explain.
                </td>
                <td colSpan={1} className={`cell centerCell`}>
                  Some text details
                </td>
                <td colSpan={1} className={`cell`}>
                  <a onClick={() => this.expandWriting(4)}>
                    <Glyphicon icon="new-window" />
                  </a>
                </td>
            </tr>
            {this.generateAnswer(4)}
            </tbody>

          
            <tbody>
              <tr>
                <td colSpan={1} className={`cell`}>
                  <div className={`readBookCell backgroundColor-green`}>
                    <div className={`readBookCellValue fontColor-green`}>Yes</div>
                  </div>
                </td>
                <td colSpan={1} className={`cell centerCell`}>
                  Quiz Free Response
                </td>
                <td colSpan={1} className={`cell`}>
                  In what ways did you notice the plot helping you understand the theme more clearly?
                </td>
                <td colSpan={1} className={`cell centerCell`}>
                  Enough text details
                </td>
                <td colSpan={1} className={`cell`}>
                  <a onClick={() => this.expandWriting(5)}>
                    <Glyphicon icon="new-window" />
                  </a>
                </td>
            </tr>
            {this.generateAnswer(5)}
            </tbody>

          
            <tbody>
              <tr>
                <td colSpan={1} className={`cell`}>
                  <div className={`readBookCell backgroundColor-green`}>
                    <div className={`readBookCellValue fontColor-green`}>Yes</div>
                  </div>
                </td>
                <td colSpan={1} className={`cell centerCell`}>
                  Practice Question
                </td>
                <td colSpan={1} className={`cell`}>
                  What made the main character unique?
                </td>
                <td colSpan={1} className={`cell centerCell`}>
                  Enough text details
                </td>
                <td colSpan={1} className={`cell`}>
                  <a onClick={() => this.expandWriting(6)}>
                    <Glyphicon icon="new-window" />
                  </a>
                </td>
            </tr>
            {this.generateAnswer(6)}
            </tbody>
        </table>
      </div>
    );
  }
};

var COLUMN_HEADERS = ['Read Book', 'Type', 'Question', 'Reason', '']

var ANSWERS = [
  <tr className="writingView">
    <td className='noBorderTop' colSpan={_.size(COLUMN_HEADERS)}>
      <div className="writingContainer fitb">
        Castle steals <span className="answerGiven backgroundColor-green fontColor-green">sunflower seeds</span> from a store.
      </div>
      <div className="answerKeyContainer">
        <span className="answerKey">Answer key:</span> sunflower seeds, sunflower
      </div>
    </td>
  </tr>,
  <tr className="writingView">
    <td className='noBorderTop' colSpan={_.size(COLUMN_HEADERS)}>
      <div className="writingContainer fitb">
        Ghost's <span className="answerGiven backgroundColor-red fontColor-red">dad</span> tries to shoot him.
      </div>
      <div className="answerKeyContainer">
        <span className="answerKey">Answer key:</span> mom, mother
      </div>
    </td>
  </tr>,
  <tr className="writingView">
    <td className='noBorderTop' colSpan={_.size(COLUMN_HEADERS)}>
      <div className="writingContainer fitb">
        Castle joins the <span className="answerGiven backgroundColor-green fontColor-green">track</span> team.
      </div>
      <div className="answerKeyContainer">
        <span className="answerKey">Answer key:</span> track
      </div>
    </td>
  </tr>,
  <tr className="writingView">
    <td className='noBorderTop' colSpan={_.size(COLUMN_HEADERS)}>
      <div className="writingContainer fitb">
        Castle steals sunflower seeds from a <span className="answerGiven backgroundColor-green fontColor-green">store</span>.
      </div>
      <div className="answerKeyContainer">
        <span className="answerKey">Answer key:</span> store, convenience store, grocery store
      </div>
    </td>
  </tr>,
  <tr className="writingView">
    <td className='noBorderTop' colSpan={_.size(COLUMN_HEADERS)}>
      <div className="writingContainer freeResponse">
        Two characters in the text who had a relationship were <span className="textDetails backgroundColor-green fontColor-green">castle and Mr. Charles</span> The relationship between these two characters made the <span className="textDetails backgroundColor-green fontColor-green">characters feel safe Mr. Charles was like a father figure</span>. Details that support this are when <span className="textDetails backgroundColor-green fontColor-green">castles dad went on a rampage and got drunk Mr. Charles was there to help them and make him feel safe</span>.
      </div>
    </td>
  </tr>,
  <tr className="writingView">
    <td className='noBorderTop' colSpan={_.size(COLUMN_HEADERS)}>
      <div className="writingContainer freeResponse">
        The plot helped me understand the theme more clearly by by showing me that even though life has struggles you always keep going, <span className="textDetails backgroundColor-green fontColor-green">castle has had a hard life</span> and they help me understand by him still <span className="textDetails backgroundColor-green fontColor-green">pushing through all of his problems and doing what he started to love</span>.
      </div>
    </td>
  </tr>,
  <tr className="writingView">
    <td className='noBorderTop' colSpan={_.size(COLUMN_HEADERS)}>
      <div className="writingContainer freeResponse">
        The main character <span className="textDetails backgroundColor-green fontColor-green">castle</span> was very unique because he was <span className="textDetails backgroundColor-green fontColor-green">born with a gift to run</span>, even thought <span className="textDetails backgroundColor-green fontColor-green">he has never trained or played sports in his life he was born with incredible speed</span>, and he also <span className="textDetails backgroundColor-green fontColor-green">wasn't the regular kid with good clothes and an amazing life , he didn't have as much money as everyone but he always managed to have a good spirit</span>.
      </div>
    </td>
  </tr>,
]



BookAnswersAnalysisTable.propTypes = StrictPropTypes({
  textID: PropTypes.string,
  userID: PropTypes.number
});

module.exports = BookAnswersAnalysisTable;



// WEBPACK FOOTER //
// ./modules/components/data/subjects/shared/BookAnswersAnalysisTable.js